import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import pages from "../publicPageSeo.json";

// Initial HTML is generated with the same metadata during the production build.
// Keep browser navigation consistent when React changes routes without a reload.
export default function PublicPageMetadata() {
  const { pathname } = useLocation();
  useEffect(() => {
    const route = pathname === "/" ? "/" : pathname.replace(/\/$/, "");
    const canonicalRoute = ["/launch", "/app-preview"].includes(route) ? "/" : route;
    const page = pages.find((item) => item.route === canonicalRoute);
    if (!page) return;
    const url = `https://snowsproam.com${page.route === "/" ? "/" : page.route}`;
    document.title = page.title;
    for (const [attribute, name, value] of [
      ["name", "description", page.description],
      ["property", "og:title", page.title],
      ["property", "og:description", page.description],
      ["property", "og:url", url],
      ["name", "twitter:title", page.title],
      ["name", "twitter:description", page.description],
      ["name", "twitter:url", url],
    ]) {
      const element = document.head.querySelector(`meta[${attribute}="${name}"]`);
      element?.setAttribute("content", value);
    }
    document.head.querySelector('link[rel="canonical"]')?.setAttribute("href", url);
    const structured = document.head.querySelector('script[type="application/ld+json"]');
    if (structured) {
      try {
        const data = JSON.parse(structured.textContent);
        const webPage = data["@graph"]?.find((node) => node["@type"] === "WebPage");
        if (webPage) {
          Object.assign(webPage, { "@id": `${url}#webpage`, url, name: page.title, description: page.description });
          if (page.route === "/") {
            webPage.mainEntity = { "@id": "https://snowsproam.com/#app" };
          } else {
            delete webPage.mainEntity;
            delete webPage.mentions;
          }
          structured.textContent = JSON.stringify(data);
        }
      } catch {
        // Preserve the server-supplied metadata if an unrelated script changed it.
      }
    }
  }, [pathname]);
  return null;
}
